import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { FormattedDate } from '@dbk/format';
import Text from '../../../components/common/text';
import omit from 'lodash/omit';
import { NO_DATA } from '../../../constants';

const SimpleDate = (props) => {
  if (props.value && typeof props.value === 'string') {
    return props.month != null || props.month != undefined ? (
      <FormattedDate
        day="2-digit"
        month="long"
        year="numeric"
        value={props.value != null ? new Date(props.value) : NO_DATA}
        {...omit(props, 'value', 'renderProps')}
      >
        {(txt) => (
          <Text secondary style={{ flex: 1 }} {...props.renderProps}>
            {txt}
          </Text>
        )}
      </FormattedDate>
    ) : (
      <FormattedDate
        day="2-digit"
        month="short"
        year="numeric"
        value={props.value != null ? new Date(props.value) : NO_DATA}
        {...omit(props, 'value', 'renderProps')}
      >
        {(txt) => (
          <Text secondary style={{ flex: 1 }} {...props.renderProps} {...omit(props, 'value', 'renderProps')}>
            {txt}
          </Text>
        )}
      </FormattedDate>
    );
  }
  return <Text secondary {...props.renderProps}>{NO_DATA}</Text>;
};

SimpleDate.propTypes = {
  ...FormattedDate.PropTypes,
  value: PropTypes.any,
  month: PropTypes.string,
};

export default pure(SimpleDate);
